import React from 'react'


const SliderBasicItemWeischer = ({
    index, 
    weischerData,
    isMobileHero = false,
    hasLoginHeader = ''
}) => {
    const { payload, pk, fallbackImage, fallbackLink } = weischerData 

    return <div key={index} className={isMobileHero ? 'weischer-slider-mobile-container' + hasLoginHeader : "weischer-item-container"} id={pk}>
        <div className={isMobileHero ? "weischer-slider-mobile-hero  weischer-item" : "weischer-item-main weischer-item"} id={payload}></div>

        {fallbackImage && <div className={isMobileHero ? "weischer-item-fallback-image-container-mobile" : "weischer-item-fallback-image-container"}>
            {fallbackLink ? fallbackLink.destinationType === 'external' ? (
                <div className={isMobileHero ? "weischer-item-mobile-hero" : "weischer-item-main"}>
                    <a className='weischer-item-fallback-link' href={fallbackLink.url} target={"_blank"}>
                        <img className={isMobileHero ? "weischer-item-fallback-image-mobile" : "weischer-item-fallback-image"} src={fallbackImage.url}></img>
                    </a>
                </div>
            ) : (
                <div className={isMobileHero ? "weischer-item-mobile-hero" : "weischer-item-main"}>
                    <a className='weischer-item-fallback-link' href={fallbackLink.url}>
                        <img className={isMobileHero ? "weischer-item-fallback-image-mobile" : "weischer-item-fallback-image"} src={fallbackImage.url}></img>
                    </a>
                </div>
            ) : (
                <div className={isMobileHero ? "weischer-item-mobile-hero" : "weischer-item-main"}>
                    <img className={isMobileHero ? "weischer-item-fallback-image-mobile" : "weischer-item-fallback-image"} src={fallbackImage.url}></img>
                </div>
            )}
        </div>}
    </div>
}

export default SliderBasicItemWeischer